import LocalizedStringsTranslator from './Translator';
export var createTranslator = function (languages) {
    return new LocalizedStringsTranslator(languages);
};
